import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';

import * as serviceWorker from './serviceWorker';
import App from './App';
import mobileAndTabletCheck from 'utils/mobileAndTabletCheck';
import DOMPurify from 'dompurify';
import { isErrorReported } from 'utils/apiError';

window.isMobile = mobileAndTabletCheck();

// Failed API calls are already shown to the user by the response interceptor, so
// they must not surface a second time as an unhandled rejection.
window.addEventListener('unhandledrejection', event => {
	if (isErrorReported(event.reason)) event.preventDefault();
});

if (window.trustedTypes && !window.trustedTypes.defaultPolicy) {
	window.trustedTypes.createPolicy('default', {
		createHTML: (input) => {
			if (typeof input !== 'string') {
				throw new TypeError('Expected a string for HTML content');
			}
			return DOMPurify.sanitize(input, { RETURN_TRUSTED_TYPE: true });
		},
		createScriptURL: () => {
			throw new TypeError('Disabled for security reasons.');
		},
		createScript: () => {
			throw new TypeError('Disabled for security reasons.');
		},
	});
}


Sentry.init({
	dsn: process.env.SENTRY_DSN,
	integrations: [new Sentry.BrowserTracing()],

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 1.0,
});

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
